var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Gauge component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconGauge extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.9995 4.22656C10.2059 4.22656 8.43999 4.66938 6.8586 5.51572C5.27721 6.36205 3.92923 7.58572 2.93431 9.0781C1.93938 10.5705 1.3283 12.2854 1.1553 14.0707C0.98229 15.8559 1.25272 17.6563 1.94257 19.3119C2.05902 19.5914 2.3321 19.7735 2.63488 19.7735H11.9772C11.9917 19.7739 12.0062 19.7739 12.0207 19.7735H21.3641C21.6669 19.7735 21.94 19.5914 22.0564 19.3119C22.7463 17.6563 23.0167 15.8559 22.8437 14.0707C22.6707 12.2854 22.0596 10.5705 21.0647 9.0781C20.0698 7.58572 18.7218 6.36205 17.1404 5.51572C15.559 4.66938 13.7931 4.22656 11.9995 4.22656ZM13.3244 18.2735H20.85C21.3121 16.9759 21.4839 15.5904 21.3507 14.2154C21.2015 12.6759 20.6745 11.1971 19.8166 9.91015C18.9587 8.62324 17.7963 7.56804 16.4326 6.83823C15.0689 6.10842 13.5462 5.72656 11.9995 5.72656C10.4528 5.72656 8.93006 6.10842 7.56639 6.83823C6.20272 7.56804 5.04033 8.62324 4.18238 9.91015C3.32444 11.1971 2.79749 12.6759 2.6483 14.2154C2.51505 15.5904 2.68686 16.9759 3.14899 18.2735H11.5751L16.0388 10.834C16.2519 10.4788 16.7126 10.3636 17.0678 10.5767C17.423 10.7898 17.5382 11.2505 17.3251 11.6057L13.3244 18.2735Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconGauge.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconGauge.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconGauge.prototype, "size", void 0);
if (customElements.get('cat-icon-gauge') === undefined) {
    customElements.define('cat-icon-gauge', BlocksIconGauge);
}
